import { Box, T } from '@veracity/vui'

import { TooltipIcon } from '@/components'
import { ScenarioDetailed } from '@/interfaces'
import { calculationStatusDictionary } from '@/utils'

import { useScenarioCalculationFailMessage } from '../../hooks'

interface Props {
  scenarioInfo: ScenarioDetailed
}

export const ScenarioDetailsStatus = ({ scenarioInfo }: Props) => {
  const calculationFailMessage = useScenarioCalculationFailMessage(scenarioInfo)
  return (
    <Box gap={1} align="center">
      <T textAlign="center" size="lg">
        {calculationStatusDictionary[scenarioInfo.state]}
      </T>
      {calculationFailMessage && (
        <TooltipIcon.Error tooltipText={calculationFailMessage} />
      )}
    </Box>
  )
}
